<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/boAvH0/tc-custom/9781467440646.jpg?1744427695180" alt="This image is the cover for the book The Psalms as Christian Lament"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Psalms as Christian Lament
      </h1>
      <p class="bookDescription body article font2">
        <i>The Psalms as Christian Lament</i>, a companion volume to <i>The Psalms as Christian Worship</i>, uniquely blends verse-by-verse commentary with a history of Psalms interpretation in the church from the time of the apostles to the present. Bruce Waltke, James Houston, and Erika Moore examine ten lament psalms, including six of the seven traditional penitential psalms, covering Psalms 5, 6, 7, 32, 38, 39, 44, 102, 130, and 143. The authors -- experts in the subject area -- skillfully establish the meaning of the Hebrew text through careful exegesis and trace the church's historical interpretation and use of these psalms, highlighting their deep spiritual significance to Christians through the ages.<br/><br/> Though C. S. Lewis called the "imprecatory" psalms "contemptible," Waltke, Houston, and Moore show that they too are profitable for sound doctrine and so for spiritual health, demonstrating that lament is an important aspect of the Christian life.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bruce K. Waltke, James M. Houston, Erika Moore
      </h2>
      
      <p class="authorDescription body article"><B>Bruce K. Waltke</B>&#160;is professor emeritus of biblical studies at Regent College, Vancouver, and distinguished professor emeritus of Old Testament at Knox Theological Seminary, Fort Lauderdale. He was a translator of the New American Standard Version of the Bible and is also a member of the committee responsible for the New International Version.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65d3ccf0